import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MyRouter from "./Components/MyRouter";

const queryClient = new QueryClient();

function App() {
  return (
      <QueryClientProvider client={queryClient}>
        <MyRouter />
      </QueryClientProvider>
  );
}

export default App;
